export default {
  push: payload => {
    if (process.env.TRACK_GA === "true") {
      window.dataLayer?.push(payload)
    } else {
      console.log("gtm", payload)
    }
  },
}
